export const SERVER_ENDPOINT = process.env.NEXT_PUBLIC_MP_BE_ENDPOINT;
export const RAZORPAY_SUCCESS_CALLBACK_URL = `${SERVER_ENDPOINT}payment/razor-success`;
export const RAZORPAY_FAILURE_CALLBACK_URL = `${SERVER_ENDPOINT}payment/razor-failure`;
export const RAZORPAY_MODAL_CT_LOGO =
  'https://assets1.cleartax-cdn.com/cleartax-brand/logos/2018/01/pinchy_yellow_black.png';
export const RAZORPAY_SDK_SRC = 'https://checkout.razorpay.com/v1/checkout.js';
export const RAZORPAY_SDK_FOR_PHONEPE_SRC =
  'https://checkout.razorpay.com/v1/razorpay.js';
export const RAZORPAY_MODAL_COLOR = '#1678FB';
export const RAZORPAY_MAX_RETRIES = 4;
